const base = '/statistics',
    basePath = `pages${base}`;
export default [
    {
        path:`${base}/index`,
        name:'statisticsIndex',
        component:r => require.ensure([], () => r(require(`@/${basePath}/index`)), 'statistics'),
        meta:{
            tit:'统计'
        }
    }
]


// WEBPACK FOOTER //
// ./src/router/router/statistics.js